/**
 * CHECK-DELETE
 * Enter code before doing a sensible operation
 */

import Button from "@/components/button"
import { useState } from "react"
import { connect } from "react-redux"
import { withTranslation, WithTranslation } from "react-i18next"
import Space from "@/components/space"
import TextInput from "@/components/text-input"
import Tooltip from "@/components/tooltip"
import { toast } from "react-toastify"
import { STATUS_SAVING } from "@/redux/_status.types"
import { Session } from "@/redux/_session.types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClipboard } from "@fortawesome/free-solid-svg-icons"

interface StateProps{
  _session : Session
}

interface OwnProps{
  labelCta? : string
  onCancel : Function
  onNext : Function
  status : string
}

type Props = StateProps & OwnProps & WithTranslation

function CheckDeleteWidget(props:Props) {
  const { t } = props
  
  //Value in text input
  const [code, setCode] = useState("")
  const [initialCode] = useState(Math.floor(Math.random() * (9999 - 1000 + 1) + 1000).toString())

  //Check if the name in textInput match with the code
  //> if ok go next
  function next(){
    if (code !== initialCode){
      toast(t("utils_delete_enter_error"), { type : 'error' })
    }else{
      props.onNext()
    }
  }

  //Copy the validation code to clipboard
  function copyCode(){
    navigator.clipboard.writeText(initialCode)
    toast(t("utils_copy_code_done"))
  }

  //Split the sentence around the code so the copy icon can sit right next to it
  const enterText = t("utils_delete_enter", { name : initialCode })
  const codeIndex = enterText.indexOf(initialCode)
  const beforeCode = codeIndex >= 0 ? enterText.slice(0, codeIndex) : enterText
  const afterCode = codeIndex >= 0 ? enterText.slice(codeIndex + initialCode.length) : ""

  return (
    <div>

      <div style={{ margin: "8px 0px" }}>
        {beforeCode}
        {initialCode}
        {codeIndex >= 0 && props._session.connectedAsSupervisor && (
          <Tooltip text={t("utils_copy")}>
            <FontAwesomeIcon
              icon={faClipboard}
              onClick={copyCode}
              className="cursor-pointer"
              style={{ marginLeft: 4, color: props._session.accountColors.active }}
            />
          </Tooltip>
        )}
        {afterCode}
      </div>

      <TextInput title={t("utils_delete_label")}
        onChange={(e) => setCode(e.value)}
        placeholder={initialCode}
        value={code}
      />

      <div className="height-40"/>

      <div className="flex">
        <Space/>
        <Button onClick={() => props.onCancel()}>
          {t("utils_cancel")}
        </Button>
        <Button onClick={next}
          isLoading={props.status === STATUS_SAVING}
          className="warning">
          {props.labelCta ? props.labelCta : t("utils_delete")}
        </Button>
      </div>

    </div>
  )
  
}

const mapStateToProps = (state) => ({
  _session: state._session
})

export default connect(mapStateToProps)(withTranslation()(CheckDeleteWidget))